import antdPT from 'antd/lib/locale-provider/pt_BR';
import ptMessages from '../locales/pt_BR.json';

const ptLang = {
    messages: ptMessages,
    antd: antdPT,
    locale: 'pt',
};
export default ptLang;
